import dayjs from "dayjs";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { createFullDateString, getGradCollection } from "./appUtils";

const gradCollection = getGradCollection();

const formatValueForPdf = ({ member, column, siteName }) => {
  const value = member?.[column.value];
  if (column.data === "contract") {
    const contractValue = member?.contractRef?.[column.value];
    return contractValue == null ? "" : `${contractValue}`;
  }

  switch (column.value) {
    case "degree": {
      if (Number.isFinite(Number(value))) {
        const grad = gradCollection[Number(value)];
        return grad?.title || "";
      }
      return "";
    }
    case "birthdate":
    case "contractDate":
    case "beginningDate":
    case "lastTesting":
    case "createdAt":
      return value ? createFullDateString(new Date(value)) : "";
    case "standortRef":
      return siteName || member?.standortRef?.siteName || "";
    case "age":
      return Number.isFinite(Number(value)) ? `${value}` : "";
    default:
      return value == null ? "" : `${value}`;
  }
};

export const makeSiteOverviewPdf = ({
  members,
  siteName,
  selectedColumns,
  stats,
  ageGroups,
}) => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const left = 40;
  let y = 40;

  doc.setFontSize(16);
  doc.text("Standortübersicht", left, y);
  y += 20;

  doc.setFontSize(12);
  doc.text(`Standort: ${siteName || ""}`.trim(), left, y);
  y += 16;
  doc.text(`Datum: ${dayjs().format("DD.MM.YYYY")}`, left, y);
  y += 20;

  doc.setFontSize(12);
  doc.text("Zusammenfassung", left, y);
  y += 14;
  doc.setFontSize(10);
  doc.text(`Aktive Mitglieder: ${stats?.totalActive ?? 0}`, left + 10, y);
  y += 12;
  doc.text(
    `Neue Mitglieder (${stats?.monthLabel || ""}): ${
      stats?.newMembersThisMonth ?? 0
    }`,
    left + 10,
    y
  );
  y += 12;
  doc.text(
    `Kündigungen (${stats?.monthLabel || ""}): ${
      stats?.terminationsThisMonth ?? 0
    }`,
    left + 10,
    y
  );
  y += 16;

  doc.setFontSize(12);
  doc.text("Aktive Mitglieder nach Altersgruppe", left, y);
  y += 8;

  const ageTableBody = [
    ["Altersgruppe", "Aktive"],
    ...(ageGroups || []).map((group) => [
      `${group.label} (${group.rangeLabel})`,
      `${group.value}`,
    ]),
  ];

  autoTable(doc, {
    startY: y,
    head: [ageTableBody[0]],
    body: ageTableBody.slice(1),
    margin: { left, right: left },
    styles: { fontSize: 9, cellPadding: 4, valign: "middle" },
    headStyles: { fillColor: [245, 245, 245], textColor: 0 },
  });

  y = doc.lastAutoTable.finalY + 16;

  doc.setFontSize(12);
  doc.text("Mitgliederliste", left, y);
  y += 8;

  const memberTableBody = (members || []).map((member) =>
    selectedColumns.map((col) =>
      formatValueForPdf({ member, column: col, siteName })
    )
  );

  autoTable(doc, {
    startY: y,
    head: [selectedColumns.map((col) => col.label)],
    body: memberTableBody,
    margin: { left, right: left },
    styles: { fontSize: 9, cellPadding: 4, valign: "middle" },
    headStyles: { fillColor: [245, 245, 245], textColor: 0 },
  });

  doc.save(
    `Standortuebersicht_${(siteName || "Standort")
      .replace(/\s+/g, "_")
      .replace(/[^\w-]/g, "")}_${dayjs().format("YYYYMMDD")}.pdf`
  );
};
